"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * API V1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.ServiceChargesDetailsToJSON = exports.ServiceChargesDetailsFromJSONTyped = exports.ServiceChargesDetailsFromJSON = exports.instanceOfServiceChargesDetails = void 0;
var runtime_1 = require("../runtime");
/**
 * Check if a given object implements the ServiceChargesDetails interface.
 */
function instanceOfServiceChargesDetails(value) {
    var isInstance = true;
    return isInstance;
}
exports.instanceOfServiceChargesDetails = instanceOfServiceChargesDetails;
function ServiceChargesDetailsFromJSON(json) {
    return ServiceChargesDetailsFromJSONTyped(json, false);
}
exports.ServiceChargesDetailsFromJSON = ServiceChargesDetailsFromJSON;
function ServiceChargesDetailsFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'referenceId': !(0, runtime_1.exists)(json, 'reference_id') ? undefined : json['reference_id'],
        'serviceCharges': !(0, runtime_1.exists)(json, 'service_charges') ? undefined : json['service_charges'],
        'tax': !(0, runtime_1.exists)(json, 'tax') ? undefined : json['tax'],
        'creditCardLastFour': !(0, runtime_1.exists)(json, 'credit_card_last_four') ? undefined : json['credit_card_last_four'],
    };
}
exports.ServiceChargesDetailsFromJSONTyped = ServiceChargesDetailsFromJSONTyped;
function ServiceChargesDetailsToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'reference_id': value.referenceId,
        'service_charges': value.serviceCharges,
        'tax': value.tax,
        'credit_card_last_four': value.creditCardLastFour,
    };
}
exports.ServiceChargesDetailsToJSON = ServiceChargesDetailsToJSON;
